export const isBzstValidatorCountry = ({
  bzstCountries,
  country,
}: {
  bzstCountries?: string;
  country: string;
}): boolean => {

  if (!bzstCountries) {

    return false;

  }

  return bzstCountries
    .split(',')
    .map(bzstCountry => bzstCountry.trim().toLowerCase())
    .includes(country.toLowerCase());

};
